import { StatusBadge } from '../../Moonstar/StatusBadge';
import { formatKpiPerformance, getKpiPerformanceLevel } from './kpiPerformance';

/** The performance as a percentage, coloured by how good it is */
export const KpiPerformanceBadge = ({ value }: { value: number }) => (
  <StatusBadge level={getKpiPerformanceLevel(value)}>
    {formatKpiPerformance(value)}
  </StatusBadge>
);
